export const TEAMS_TOP_LIMIT = 100;

export const TEAM_TABLE_ROW_HEIGHT = 72;
export const TEAM_TABLE_BORDER = "#E5E5E5";

export const TEAM_TABLE_HEADER_CELL_CLASS =
  "h-10 border-b border-[#E5E5E5] p-2 text-center align-middle whitespace-nowrap text-[10px] font-medium leading-5 text-[#737373]";

export const TEAM_TABLE_BODY_CELL_CLASS =
  "box-border overflow-hidden border-b border-[#E5E5E5] p-2 text-center align-middle text-sm text-[#171717]";

export const TEAM_PODIUM_CARD_PADDING = 16;
export const TEAM_PODIUM_CARD_GAP = 8;
export const TEAM_PODIUM_METRIC_LABEL_GAP = 2;
export const TEAM_PODIUM_CARD_RADIUS = 32;
export const TEAM_PODIUM_CARD_BG = "#F9FAFB";
export const TEAM_PODIUM_AVATAR_SIZE = 128;
export const TEAM_PODIUM_RANK_BADGE_SIZE = 48;
export const TEAM_PODIUM_WINNER_NAME_BADGE_GAP = 4;
export const TEAM_PODIUM_WINNER_BADGE_COLOR = "#826BFF";
export const TEAM_PODIUM_WINNER_CROWN_COLOR = "#EAB308";
export const TEAM_PODIUM_NAME_COLOR = "#0A0A0A";

export const TEAM_PODIUM_RANK_STYLES = {
  1: {
    border: "#FACC15",
    background: "#FEFCE8",
    circleBg: "#FACC15",
    circleText: "#FFFFFF",
    badgeText: TEAM_PODIUM_WINNER_BADGE_COLOR,
  },
  2: {
    border: "#9CA3AF",
    background: TEAM_PODIUM_CARD_BG,
    circleBg: "#9CA3AF",
    circleText: "#FFFFFF",
    badgeBg: "#F5F5F5",
    badgeText: "#525252",
  },
  3: {
    border: "#F97316",
    background: TEAM_PODIUM_CARD_BG,
    circleBg: "#F97316",
    circleText: "#FFFFFF",
    badgeBg: "#FFEDD5",
    badgeText: "#9A3412",
  },
} as const;

export const TEAM_ICON_COLOR = "#878065";
export const TEAM_ICON_SIZE = 24;

export const TEAM_STAFF_CHART_COLORS = {
  tasksCompleted: "#826BFF",
  avgTimeOnTask: "#9B90DA",
  delays: "#C6C1A4",
  tasksCancelled: "#826BFF",
} as const;

export const TEAM_STAFF_DETAIL_CHART_HEIGHT = 504;
